//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';
import { TagDisplayItem } from './TagDisplayItem';
import { PackageExpiryType, PackageVisibility, PackageStatus } from './Enums';

export class PackageDefinitionDisplayItem extends ItemBase {
    ID: string | null = null;
    SchoolID: string | null = null;
    TeacherIDs: string[] = [];
    Teachers: TeacherNameDisplayItem[] = [];
    Name: string | null = null;
    Description: string | null = null;
    DurationInMinutes: number = 0;
    TagIDs: string[] = [];
    Tags: TagDisplayItem[] = [];
    Price: number = 0;
    ExpiryType: PackageExpiryType = PackageExpiryType.None;
    DaysToExpire: number | null = null;
    CreatedDate: string = "1970-01-01T00:00:00";
    Visibility: PackageVisibility = PackageVisibility.None;
    Status: PackageStatus = PackageStatus.Active;
    ShowDiscount: boolean = false;

    constructor(initializer?: Partial<PackageDefinitionDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PackageDefinitionDisplayItem";
}
